import { ComponentType, ReactNode } from "react";
import { IconType } from "react-icons";
import {
    FaUsers,
    FaBook,
    FaBuilding,
    FaDoorOpen,
    FaFileAlt,
    FaPencilAlt,
    FaFile,
    FaChartBar,
    FaCogs,
    FaSpellCheck,
    FaChalkboardTeacher,
    FaClipboardCheck,
    FaCalculator,
    FaChartLine,
    FaUserFriends
} from "react-icons/fa";

import {
    DanhSachThiSinhLopPage,
    DanhSachThiSinhPage,
    DongTuiLapPhachPage,
    GanMonHocPage,
    LopHocPage,
    NhapDiemTheoLopPage,
    ToChucThiPhongPage,
    TongHopDiemPage
} from "../pages";

import LoaiNganhPage from "../pages/xet-tuyen-thac-sy/loai-nganh";
import MonHocPage from "../pages/xet-tuyen-thac-sy/mon-hoc/MonHocPage";
import DotHocPage from "../pages/xet-tuyen-thac-sy/dot-hoc/DotHocPage";
import HomePage from "../pages/home";
import { CandidateStatisticsRedirect, LearnerStatisticsRedirect } from "../pages/home/HomePage";
import ThamSoPage from "../pages/xet-tuyen-thac-sy/tham-so-he-thong/ThamSoPage";

export type RouteProps = {
    path: string | null | undefined;
    name: string;
    permission?: string;
    icon?: IconType | ReactNode | ComponentType<any> | JSX.Element | any;
    children?: RouteProps[];
    component?: ComponentType<any>;
    showInMenu?: boolean;
};

const routes: RouteProps[] = [
    {
        path: undefined,
        name: "Tổng quan",
        icon: FaChartLine,
        showInMenu: true,
        children: [
            {
                path: "/Dashboard",
                name: "Dashboard",
                permission: "BSKT_DASHBOARD",
                component: HomePage,
                icon: FaChartLine,
                showInMenu: true
            }
        ]
    },
    {
        path: undefined,
        name: "Tuyển sinh",
        icon: FaSpellCheck,
        showInMenu: true,
        children: [
            {
                path: "/danh-sach-thi-sinh",
                name: "Danh sách thí sinh",
                permission: "BSKT_HOCVIEN",
                component: DanhSachThiSinhPage,
                icon: FaUserFriends,
                showInMenu: true
            },
            {
                path: "/thong-ke-thi-sinh-bskt",
                name: "Thống kê thí sinh",
                permission: "BSKT_THONGKE_THISINH",
                component: CandidateStatisticsRedirect,
                icon: FaFileAlt,
                showInMenu: false
            },
        ]
    },
    {
        path: undefined,
        name: "Lớp",
        icon: FaChalkboardTeacher,
        showInMenu: true,
        children: [
            {
                path: "/danh-sach-lop",
                name: "Lịch học - thi bổ sung kiến thức",
                permission: "BSKT_DANHSACH_LOP",
                component: LopHocPage,
                icon: FaBuilding,
                showInMenu: true
            },
            {
                path: "/danh-sach-thi-sinh-theo-lop",
                name: "Danh sách học viên",
                permission: "BSKT_HOCVIEN_LOP",
                component: DanhSachThiSinhLopPage,
                icon: FaUsers,
                showInMenu: true
            },
            {
                path: "/thong-ke-hoc-vien-bskt",
                name: "Thống kê học viên",
                permission: "BSKT_THONGKE_HOCVIEN",
                component: LearnerStatisticsRedirect,
                icon: FaFileAlt,
                showInMenu: false
            }
        ]
    },
    {
        path: undefined,
        name: "Điểm",
        icon: FaCalculator,
        showInMenu: true,
        children: [
            {
                path: "/nhap-diem-theo-lop",
                name: "Nhập điểm theo lớp",
                permission: "BSKT_NHAPDIEM",
                component: NhapDiemTheoLopPage,
                icon: FaPencilAlt,
                showInMenu: true
            },
            {
                path: "/tong-hop-diem",
                name: "Tổng hợp điểm",
                permission: "BSKT_TONGHOPDIEM",
                component: TongHopDiemPage,
                icon: FaChartBar,
                showInMenu: true
            }
        ]
    },
    {
        path: undefined,
        name: "Thiết lập",
        icon: FaCogs,
        showInMenu: true,
        children: [
            {
                path: "/mon-hoc",
                name: "Danh mục môn học",
                permission: "BSKT_MONHOC",
                component: MonHocPage,
                icon: FaBook,
                showInMenu: true
            },
            {
                path: "/dot-hoc",
                name: "Thiết lập đợt học",
                permission: "BSKT_DOTHOC",
                component: DotHocPage,
                icon: FaBook,
                showInMenu: true
            }
        ]
    },
    {
        path: undefined,
        name: "Tổ chức thi",
        icon: FaClipboardCheck,
        showInMenu: false,
        children: [
            {
                path: "/to-chuc-thi-phong",
                name: "Tổ chức thi phòng",
                permission: "TOCHUCTHI_PHONG",
                component: ToChucThiPhongPage,
                icon: FaDoorOpen,
                showInMenu: true
            },
            {
                path: "/dong-tui-lap-phach",
                name: "Đóng túi lập phách",
                permission: "TOCHUCTHI_DONGTUI",
                component: DongTuiLapPhachPage,
                icon: FaFile,
                showInMenu: true
            }
        ]
    },
    {
        path: undefined,
        name: "Thiết lập (ẩn)",
        icon: null,
        showInMenu: false,
        children: [
            {
                path: "/thiet-lap-loai-nganh",
                name: "Thiết lập loại ngành",
                permission: "THIETLAP_LOAINGANH",
                component: LoaiNganhPage,
                icon: FaBuilding,
                showInMenu: true
            },
            {
                path: "/thiet-lap-tham-so",
                name: "Thiết lập tham số",
                permission: "THIETLAP_THAMSO",
                component: ThamSoPage,
                icon: FaBuilding,
                showInMenu: true
            },
            {
                path: "/xet-tuyen-thac-sy/gan-mon-hoc",
                name: "Gán môn học",
                permission: "THIETLAP_GANMONHOC",
                component: GanMonHocPage,
                icon: FaBook,
                showInMenu: true
            }
        ]
    }
];

export default routes;
